import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { BranchOption } from './branches.types';

/**
 * Store da empresa/filial atualmente selecionada — persistido em
 * localStorage por tenant (key `dynreport.branch.v1`).
 *
 * O HTTP client (`shared/lib/http/client.ts`) lê o `tenantHeader` daqui
 * e injeta como header `X-Protheus-Tenant` em toda request que precise
 * (configurado no beforeRequest hook do ky).
 *
 * Quando o user troca pela UI:
 *   1. setSelected(opt) atualiza store + localStorage
 *   2. Próxima request já leva o novo header
 *   3. TanStack Query invalidations cabem aqui (futuro: reset cache
 *      ao trocar de filial pra evitar mostrar dados da anterior)
 */
interface BranchesState {
  /** Branch atualmente selecionada — null antes do user escolher. */
  readonly selected: BranchOption | null;
  setSelected: (option: BranchOption | null) => void;
  /** Limpa quando o user faz logout (chamado pelo auth.store). */
  reset: () => void;
}

export const useBranchesStore = create<BranchesState>()(
  persist(
    (set) => ({
      selected: null,
      setSelected: (selected) => set({ selected }),
      reset: () => set({ selected: null }),
    }),
    { name: 'dynreport.branch.v1' },
  ),
);

/** Helper sem hook — pro http client ler fora de componentes React. */
export const getSelectedBranchHeader = (): string | null =>
  useBranchesStore.getState().selected?.tenantHeader ?? null;
